import { render } from "./FloatingWhatsApp.vue?vue&type=template&id=e8eb7100&scoped=true"
import script from "./FloatingWhatsApp.vue?vue&type=script&lang=js"
export * from "./FloatingWhatsApp.vue?vue&type=script&lang=js"

import "./FloatingWhatsApp.vue?vue&type=style&index=0&id=e8eb7100&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8eb7100"]])

export default __exports__